import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { AuthService, UsersService } from '@ubie/core';
import { FeedbackService, FormHelper } from '@ubie/shared';

@Component({
  selector: 'acl-password-form',
  standalone: false,
  templateUrl: './password-form.component.html',
  styleUrl: './password-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFormComponent {
  private readonly fb = inject(FormBuilder);
  private readonly userService = inject(UsersService);
  private readonly feedbackService = inject(FeedbackService);
  private readonly authService = inject(AuthService);

  readonly formSubmitAttempted = signal(false);

  readonly passwordForm = this.fb.group(
    {
      existingpassword: ['', [Validators.required]],
      newpassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmpassword: ['', [Validators.required]],
    },
    {
      validators: [this.matchPasswords],
    },
  );

  readonly formHelper = new FormHelper(this.passwordForm);
  readonly isFormSubmitAttempted = signal(false);

  // Custom Validator logic
  private matchPasswords(control: AbstractControl): ValidationErrors | null {
    const newPass = control.get('newpassword')?.value;
    const confirmPass = control.get('confirmpassword')?.value;
    return newPass === confirmPass ? null : { mismatch: true };
  }

  /**
   * Form is submitted
   */
  onSubmit(): void {
    this.isFormSubmitAttempted.set(true);

    if (this.passwordForm.valid) {
      this.updatePassword();
    }
  }

  updatePassword(): void {
    this.userService
      .updatePassword(
        this.authService.currentUserId(),
        this.passwordForm.getRawValue().confirmpassword ?? '',
        this.passwordForm.getRawValue().existingpassword ?? '',
      )
      .subscribe({
        next: () => {
          this.passwordForm.reset();
          this.formSubmitAttempted.set(false);

          this.feedbackService.present('profile_pwUpdateSucceeded');
        },
        error: () => {
          this.feedbackService.present('profile_pwUpdateFailed');
        },
      });
  }
}
